export default {
    // backgroundColor: 'rgb(0,157,249, 0.55)',
    backgroundColor: 'rgba(0, 157, 249, 0.55)',
    paddingRight: '3px'
  }
